<template>
  <div>
    <h6 class="mb-0">
      {{ group_prescription_medicine.prescription_medicine.medicine_name }}
    </h6>
    <h6 class="legends worksansr">
      {{
        group_prescription_medicine.prescription_medicine
          .medicine_active_ingredient
      }}
    </h6>
    <h6
      class="btn-pendent mb-2 center-text inline-display"
      v-if="
        group_prescription_medicine.prescription_medicine.type_of_recipe_name ==
        'CONTROLE ESPECIAL - 2 VIAS'
      "
    >
      CONTROLE ESPECIAL
    </h6>
    <h6
      class="legends mb-1 worksansr"
      v-if="group_prescription_medicine.prescription_medicine.medicine_list"
    >
      LISTA:
      {{ group_prescription_medicine.prescription_medicine.medicine_list }}
    </h6>
    <h6 class="legends mb-1 worksansr">
      VIA DE ADMINISTRAÇÃO:
      {{
        group_prescription_medicine.prescription_medicine
          .route_of_administration_name
      }}
    </h6>
    <h6 class="legends mb-1 worksansr">
      QUANTIDADE:

      <strong class="text-two">
        <span
          v-if="
            !group_prescription_medicine.prescription_medicine_time
              .fractional_number
          "
        >
          {{
            `${
              group_prescription_medicine.prescription_medicine_time.drops
                ? `${group_prescription_medicine.prescription_medicine_time.drops} GOTA(S)`
                : group_prescription_medicine.prescription_medicine_time.ui
                ? `${group_prescription_medicine.prescription_medicine_time.ui} UI`
                : group_prescription_medicine.prescription_medicine_time
                    .quantity
            }`
          }}
        </span>
        <span
          v-if="
            group_prescription_medicine.prescription_medicine_time
              .fractional_number
          "
        >
          <span
            v-if="
              group_prescription_medicine.prescription_medicine_time
                .text_first_number
            "
            class="c-danger"
          >
            {{
              group_prescription_medicine.prescription_medicine_time
                .text_first_number
            }}
            <sup>{{
              group_prescription_medicine.prescription_medicine_time
                .fractional_number
            }}</sup>
          </span>
          <span v-else class="c-danger">
            {{
              group_prescription_medicine.prescription_medicine_time
                .fractional_number
            }}
          </span>
        </span>
        {{
          `${
            group_prescription_medicine.prescription_medicine_time.drops
              ? ""
              : group_prescription_medicine.prescription_medicine_time.ui
              ? ""
              : `- ${group_prescription_medicine.prescription_medicine_time.unit_of_measurement_value}(S)`
          }`
        }}
      </strong>
    </h6>
    <h6
      class="legends mb-1 worksansr"
      v-if="group_prescription_medicine.prescription_medicine.instruction"
    >
      INSTRUÇÃO:
      {{ group_prescription_medicine.prescription_medicine.instruction }}
    </h6>
    <div
      v-if="
        group_prescription_medicine.prescription_medicine.frequency ==
        'EVENTUAL'
      "
    >
      <h6>
        Pode checar a cada
        {{
          handleEvery(
            group_prescription_medicine.prescription_medicine
              .medicine_amount_of_times_value
          )
        }}. ({{
          group_prescription_medicine.prescription_medicine
            .medicine_amount_of_times_value
        }}x).
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "Medicine",
  props: {
    group_prescription_medicine: Object,
  },
  methods: {
    handleEvery(value) {
      return `${Math.round(24 / value)} horas`;
    },
  },
};
</script>
